<template>
  <v-container class="max-width-1200">

    <!-- infographic -->
    <!-- <v-row>
      <v-col>
        <v-img
          src="https://www.rubin.hu/wp-content/uploads/2015/05/rendszerterv-1.png"
          max-width="800"
          contain
          class="ml-12 mx-auto">
        </v-img>
      </v-col>
    </v-row> -->

    <v-row class="justify-center">
      <v-col>

        <v-row class="justify-center">
          <v-col>
            <!-- main text -->
            <v-row>
              <v-col class="pb-0 headline text-uppercase">
                {{ $t('common.obligations') }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="display-1">
                {{ $t('tao.obligations.subtitle')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="text-justify">
                {{ $t('tao.obligations.text.01')}}<br>
                {{ $t('tao.obligations.text.02')}}
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="(item,index) in laws"
                :key="index"
                cols="12" sm="6" md="3">

                  <v-hover
                    v-slot="{ hover }">
                    <v-card
                      :elevation="hover ? 12 : 0"
                      :color="item.color"
                      dark>
                      <v-card-title>
                        {{ item.title }}
                      </v-card-title>
                      <v-card-subtitle class="">
                        {{ item.type }}
                      </v-card-subtitle>
                      <v-card-text class="min-height-100">
                        {{ item.text }}
                      </v-card-text>
                      <v-card-actions style="justify-content: flex-end;">
                        <v-btn
                          text
                          :href="item.link"
                          target="_blank">
                          {{ $t("common.link") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-hover>
                </v-col>
              </v-row>
            <v-row>

            </v-row>
          </v-col>
        </v-row>

      </v-col>
    </v-row>

  </v-container>
</template>

<script>
  import DataComponentBase from '@/commons/DataComponentBase';

  export default {
    name: 'TaoObligations',
    extends: DataComponentBase,

    data: () => ({
      laws: [
        // TODO links
        {
          color: "purple",
          link: "https://net.jogtar.hu/jogszabaly?docid=A1700176.KOR",
          title: "176/2017. (VII. 4.)",
          type: "Korm. rendelet",
          text: "az energiahatékonysági célokat szolgáló beruházás adókedvezményének végrehajtási szabályairól"
        },
        {
          color: "deep-purple",
          link: "https://net.jogtar.hu/jogszabaly?docid=a1500122.kor",
          title: "122/2015. (V. 26.)",
          type: "Korm. rendelet",
          text: "az energiahatékonyságról szóló törvény végrehajtásáról"
        },
        {
          color: "indigo",
          link: "https://net.jogtar.hu/jogszabaly?docid=99600081.tv",
          title: "1996. évi LXXXI.",
          type: "törvény",
          text: "a társasági adóról és az osztalékadóról"
        },
        {
          color: "blue",
          link: "https://net.jogtar.hu/jogszabaly?docid=A1500057.TV",
          title: "2015. évi LVII.",
          type: "törvény",
          text: "az energiahatékonyságról"
        },
      ],
    }),

    methods: {

    },
  }
</script>
